// extracted by mini-css-extract-plugin
module.exports = {"root":"newsletter-box-module--root--2ONmg","title":"newsletter-box-module--title--1CYMg","subTitle":"newsletter-box-module--sub-title--2Edlf"};